import { render, staticRenderFns } from "./FormFixedAssetInternal.vue?vue&type=template&id=01f651f0"
import script from "./FormFixedAssetInternal.vue?vue&type=script&lang=js"
export * from "./FormFixedAssetInternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports